;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';

const CompanyVideo = ({
  videoId,
  source = 'youtube',
  className,
}: {
  videoId: string;
  source?: 'youtube' | 'vimeo';
  className: string;
}) => {
  const src = source === 'youtube' ? `https://www.youtube.com/embed/${videoId}` : `https://player.vimeo.com/video/${videoId}`;

  const allow =
    source === 'youtube' ? 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' : 'autoplay; fullscreen';

  return (
    <div className={`w-100 ${className}`}>
      <div className="embed-responsive embed-responsive-16by9">
        <iframe
          title={`${source} frame`}
          className="embed-responsive-item"
          src={src}
          frameBorder="0"
          allow={allow}
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default CompanyVideo;
